function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { shouldSeeProductsPricingPage } from "services/ab-tests/monetization-ab-tests-service";
import { withGenericConfig } from "contexts/generic-config-context";
import { withAbTests } from "contexts/ab-tests-context";
import FeaturesTableComponent from "./features-table/features-table-component";
import ProductFeaturesTable from "./product-features-table/product-features-table";
import { StyledFeaturesTablePricingComponent } from "./features-table-pricing-component.scss.js";
import { shouldHideBasicTier, shouldSeeNewPricing } from "services/pricing-service";
import { CRM } from "constants/clusters";
class FeaturesTablePricingComponent extends PureComponent {
    componentDidUpdate() {
        this.checkIfShouldSeeProductsFeaturesTable();
    }
    checkIfShouldSeeProductsFeaturesTable() {
        const { productName, abTests, clusterId, hasStudentPlan, cookies, forcePricing, cloudfrontViewerCountry, isClusterMiniSitePage } = this.props;
        this.shouldSeeProductsFeaturesTable = productName && (isClusterMiniSitePage || shouldSeeProductsPricingPage({
            abTests,
            clusterId,
            hasStudentPlan,
            cookies,
            forcePricing,
            cloudfrontViewerCountry
        }));
    }
    render() {
        const { ignoreClusterConfig, isHomepagePricing, clusterId, abTests, simulateNewPricingTest, productName, persistantCookies, forceSunsetBasic } = this.props;
        // When productize handle the case that product name not always match to cluster, it works for CRM but for core not
        const isNewPricing = simulateNewPricingTest && productName === CRM || this.props.isNewPricing || shouldSeeNewPricing(productName, abTests);
        // the full feature list
        const hideBasicTier = shouldHideBasicTier({
            persistantCookies,
            clusterId,
            productName,
            abTests,
            forceSunsetBasic
        });
        return /*#__PURE__*/ _jsx(StyledFeaturesTablePricingComponent, {
            className: "features-table-pricing-component",
            children: this.shouldSeeProductsFeaturesTable || isHomepagePricing ? /*#__PURE__*/ _jsx(ProductFeaturesTable, _object_spread_props(_object_spread({}, this.props), {
                isNewPricing: isNewPricing,
                shouldHideBasicTier: hideBasicTier
            })) : /*#__PURE__*/ _jsx(FeaturesTableComponent, {
                ignoreClusterConfig: ignoreClusterConfig
            })
        });
    }
    constructor(props){
        super(props);
        this.checkIfShouldSeeProductsFeaturesTable();
    }
}
export default withAbTests(withGenericConfig(FeaturesTablePricingComponent));
